export const APP_VERSION = '9c539cd-1793282735410'
